import { ABehaviorSubjectState } from "@core/abstractions/behavior-subject-state.abstract";
import { IUser } from "@core/interfaces/user.interface";

export class UserProfileState extends ABehaviorSubjectState<Partial<IUser>> {}
